// import CONSTANTS from '@/constants';
import defaultState from './state';

const SET_USER_PROFILE = (state, { profile }) => {
  state.loggedInUserProfile = {
    ...state.loggedInUserProfile,
    ...profile,
  };
};

const SET_PROFILE = (state, profile) => {
  state.loggedInUserProfile = profile;
};

const SET_PROFILE_USER = (state, user) => {
  state.loggedInUserProfile.user = user;
};

const SET_PUSH_NOTIFICATION = (state, details) => {
  state.pushNotification = details;
};

const ISLAND_PROGRESSION_LIST = (state, list) => {
  state.islandProgressionList = list;
};

const ISLAND_PROGRESSION_ITEM = (state, item) => {
  state.islandProgressionItem = item;
};

const USER_COUNTRY = (state, country) => {
  state.userCountry = country;
};

const DESTROY = (state) => {
  Object.keys(defaultState).forEach((key) => {
    state[key] = defaultState[key];
  });
};

const SET_USER_FRIEND_LISTS = (state, lists) => {
  lists.facebook.response.list.forEach((x) => {
    x.name_hint = 'facebook';
  });
  lists.google.response.list.forEach((x) => {
    x.name_hint = 'google';
  });
  state.friendLists = lists;
};

const SAVE_TIMER = (state, data) => {
  const user = state.loggedInUserProfile.user;
  if (user.abInfo) {
    user.abInfo.lessonTimerStatistics = data;
  }
};

const SET_SESSION_TOKEN = (state, data) => {
  window.$cookies.set('api-token', data, null, null, '.xeropan.com');
  state.loggedInUserProfile.apiToken = data;
};

const SET_USER_AFTER_COLLISION = (state, data) => {
  state.userAfterCollision = data;
};

const SET_IDP_TOKEN = (state, data) => {
  state.loggedInUserProfile.idpToken = data;
};

export default {
  SET_PROFILE,
  SET_USER_PROFILE,
  SET_PROFILE_USER,
  ISLAND_PROGRESSION_LIST,
  ISLAND_PROGRESSION_ITEM,
  USER_COUNTRY,
  DESTROY,
  SET_USER_FRIEND_LISTS,
  SET_PUSH_NOTIFICATION,
  SAVE_TIMER,
  SET_SESSION_TOKEN,
  SET_USER_AFTER_COLLISION,
  SET_IDP_TOKEN,
};
